const subshopNavigation = {
    subshopLogosUnveiled: false,
    /**
     * @deprecated
     */
    subshopSelectorVisibility() {
        let pageBody = $('body');
        // on certain pages the header part is loaded lazy
        pageBody.on('click', '.page-header__subshop-selector', (evt) => {
            subshopNavigation.open();
        });

        pageBody.on('click', '.page-header__subshop-nav-close', (evt) => {
            subshopNavigation.close();
        });
    },
    /**
     * @deprecated
     */
    open() {
        let pageBody = $('body');
        this.unveilSubshopLogos();
        $('.page-header__subshop-nav-wrapper').removeClass('d-none');
        pageBody.addClass('disable-overflow');
    },
    /**
     * @deprecated
     */
    close() {
        let pageBody = $('body');
        $('.page-header__subshop-nav-wrapper').addClass('d-none');
        pageBody.removeClass('disable-overflow');
    },
    /**
     * @deprecated
     */
    subshopTooltop() {
        // add if and check if user access site for first time
        let subshopTooltip = $('.page-header__subshop-selector');
        subshopTooltip.tooltip({
            placement: 'bottom',
            trigger:   'manual',
            container: ".page-header__subshop-selector"
        }).addClass("page-header_subshop-tooltip");

        if (window.localStorage.getItem('oldUser') == null) {
            subshopTooltip.tooltip('show');
            $(window).one('click scroll touch', function () {
                subshopTooltip.tooltip('hide');
            });
            window.localStorage.setItem('oldUser', 'true');
        }
    },
    /**
     * @deprecated
     */
    selectSubshop() {
        const subShopItems = $('.page-header__subshop-items');
        subShopItems.on('click', '.page-header__subshop-item', function () {
            const subShopLink = $(this).find('a');
            if (subShopLink.attr('target') === "_blank") {
                subshopNavigation.close();
            }
        })
    },
    /**
     * @deprecated
     */
    unveilSubshopLogos() {
        if (!this.subshopLogosUnveiled) {
            this.subshopLogosUnveiled = true;
            $('.page-header__subshop-image--lazy').each((index, element) => {
                element.src = element.dataset.src;
            });
        }
    }
};

$(() => {
    if (!RedBull.config.archibaldRenderingEnabled) {
        subshopNavigation.subshopSelectorVisibility();
        subshopNavigation.subshopTooltop();
        subshopNavigation.selectSubshop();
    }
});

export default subshopNavigation;
